
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from 'react';
import { LuSettings2 } from "react-icons/lu";
import { MdFilterList } from "react-icons/md";
import Tooltip from "./Tooltip";

const ClientButton = ({clientName, clientId, displayToolTip, showFilterBtn, filtersObj}) => {
    const name = clientName.split(" ").slice(0,2);
    const initials = name.map(word => word.charAt(0));
    const navigate = useNavigate();

    const {queryParam} = useParams();
    const [isActive, setIsActive] = useState(false);
    const [filters, setFilters] = useState([]);
    const [showFilters, setShowFilters] = useState(false);
    const [showTooltip, setDistplayTooltip] = useState('');

    const handleClientRedirect = () =>{
      navigate(`/chat/${clientId}`);
    }

    const flattenJson = (nestedJson, parentKey = '', sep = '_') => {
      const items = {};
  
      // Iterate over the keys in the input JSON object
      for (const key in nestedJson) {
          if (nestedJson.hasOwnProperty(key)) {
              const value = nestedJson[key];
              // Create a new key by appending the current key to the parent key
              const newKey = parentKey ? `${parentKey}${sep}${key}` : key;
  
              if (typeof value === 'object' && !Array.isArray(value)) {
                  // Recursively flatten nested objects
                  Object.assign(items, flattenJson(value, newKey, sep));
              } else if (Array.isArray(value)) {
                  // Handle arrays of objects
                  value.forEach(item => {
                      if (typeof item === 'object') {
                          // Recursively flatten each object within the array
                          Object.assign(items, flattenJson(item, newKey, sep));
                      }
                  });
              } else {
                  // Add the key-value pair to the items object
                  items[newKey] = value;
              }
          }
      }
  
      return items;
  };

    const showFiltersDiv = (e) =>{
      if(showFilterBtn) {
        e.stopPropagation();
        var flatedJson = flattenJson(filtersObj);
        const tempFilters = [];

      for (let key in flatedJson) {
          if (flatedJson.hasOwnProperty(key)) {
              // Transform the key to a human-readable format
              const formattedKey = key
                  .replace(/_/g, ' ') // Replace underscores with spaces
                  .replace(/\b\w/g, c => c.toUpperCase()); // Capitalize the first letter of each word
      
              // Retrieve the value from the flatedJson object using the key
              const value = flatedJson[key];
      
              // Check if the value is a boolean (true or false)
              const formattedValue = value === true ? 'Yes' : value === false ? 'No' : value;
      
              // Construct the formatted string "Label: Value"
              const formattedString = `${formattedKey}: ${formattedValue}`;
      
              // Push the formatted string to the tempFilters array
              tempFilters.push(formattedString);
          }
      }
      setShowFilters(!showFilters)
      setFilters(tempFilters)
      }
    }

    const handleButtonClick = () => {
      setDistplayTooltip(false);
    };

    useEffect(() => {
      setIsActive(clientId == queryParam)
    }, [queryParam]);

    useEffect(() => {
      setDistplayTooltip(displayToolTip)
    }, [displayToolTip]);

    return (
      <div>
        <button className={`py-2 px-2 text-[#475467] rounded-lg transition-transform duration-300 hover:bg-[#F6F8FC] w-full ${isActive ? 'bg-[#F6F8FC]' : ''}`} onClick={handleClientRedirect}>
            <div className='flex justify-between items-center'>
              <div className='flex gap-2 items-center' >
                <span className="flex flex-col bg-[#EAECF0] rounded-full font-semibold justify-center capitalize text-sm" style={{ width: "1.9rem", height: "1.9rem"}}>{initials.join("")}</span>
                <span className="line-clamp-1"> {clientName} </span>
              </div>
              <LuSettings2 className={`${showFilterBtn ? "opacity-100 rotate-180": "opacity-0"} transition-all transform duration-300 p-[0.35rem] rounded-full hover:bg-[#DDE9FC] hover:text-[#0062FF]`} 
                size={30}
                onClick={showFiltersDiv}
              />
              
            </div>
            { showTooltip &&
                <div className="hidden lg:block relative right-0">
                  <Tooltip message="Please check filtering options that you inputted" buttonText="Got it!" onButtonClick={handleButtonClick} />
                </div>
              }
        </button>
        <div className="filters px-4">
          {
            showFilters && filters.map(filter => (
              <div className="grid grid-flow-col justify-start pb-1 gap-2 items-center">
                <MdFilterList size={18} color="#667085"/>
                <span className="mt-[2px] text-left text-[#667085]">{filter}</span>
              </div>
            ))
          }
        </div>
      </div>
    );
};

export default ClientButton;
